module.exports = "/assets/data/33947fe2885fbd87313962fe914a499d-GU15.data.json";